<template>
  <div class="pdf-box">
    <Pdf v-if="path" ref="jsPdf" :pdfUrl="path" :platform="platform" :watermark-text="watermark" :is_encrypt="is_encrypt"/>
  </div>
</template>

<script>
import Pdf from "@/components/pdf/index.vue";
import PdfView from "@/components/pdf-view.vue";
export default {
  components: {
      PdfView,
    Pdf,
  },
  data() {
    return {
      path:'',
      platform: 'h5',
      watermark: '搞一下',
      is_encrypt: 1,
    };
  },

  mounted() {
    const option = this.$route.query;
    this.path = option.url || '';
    this.platform = option.platform || this.platform;
    this.watermark = option.watermark || this.watermark;
    this.is_encrypt = parseInt(option.is_encrypt || 1);
  },
};
</script>
<style scoped>
.pdf-box {
  height: 100vh;
  overflow: hidden;
}
</style>
